import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { useRequest } from './useRequest';
import { API_PATH, CacheKey, CacheOperation } from '../types/shared';
import { getRequestBaseParams } from '../utils/request';
// R001：预选城市缓存过期时间（100 天）
const PRE_SELECTED_CITY_EXPIRE_SECONDS = 60 * 24 * 60 * 60 * 100;
export function useActivityCache(options) {
    const ctx = useMonitorEngineContext();
    const commonParams = ctx._runtimeInfo?.commonParams;
    const { request: activityCache } = useRequest(API_PATH.ACTIVITY_CACHE);
    // R001：读取预选城市缓存
    async function readPreSelectedCityCache() {
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const resData = await activityCache({
                activityId: options.activityId,
                key: CacheKey.PreSelectedCity,
                operation: CacheOperation.Read,
                ...feCommonParams
            });
            if (resData) {
                return JSON.parse(resData);
            }
        }
        catch { }
        return null;
    }
    // R001：写入预选城市缓存
    async function writePreSelectedCityCache(city) {
        const feCommonParams = await getRequestBaseParams(commonParams);
        await activityCache({
            activityId: options.activityId,
            key: CacheKey.PreSelectedCity,
            value: JSON.stringify({
                id: city.id,
                name: city.name
            }),
            expireSeconds: PRE_SELECTED_CITY_EXPIRE_SECONDS,
            operation: CacheOperation.WriteOverride,
            ...feCommonParams
        });
    }
    // R001：清除预选城市缓存
    async function clearPreSelectedCityCache() {
        const feCommonParams = await getRequestBaseParams(commonParams);
        await activityCache({
            activityId: options.activityId,
            key: CacheKey.PreSelectedCity,
            value: '',
            operation: CacheOperation.WriteOverride,
            ...feCommonParams
        });
    }
    // 通用读缓存
    async function readCache(key) {
        try {
            const feCommonParams = await getRequestBaseParams(commonParams);
            const resData = await activityCache({
                activityId: options.activityId,
                key,
                operation: CacheOperation.Read,
                ...feCommonParams
            });
            return resData ?? null;
        }
        catch { }
        return null;
    }
    // 通用写缓存
    async function writeCache(key, value, expireSeconds) {
        const feCommonParams = await getRequestBaseParams(commonParams);
        await activityCache({
            activityId: options.activityId,
            key,
            value,
            ...(expireSeconds !== undefined ? {
                expireSeconds
            } : {}),
            operation: CacheOperation.WriteOverride,
            ...feCommonParams
        });
    }
    return {
        readPreSelectedCityCache,
        writePreSelectedCityCache,
        clearPreSelectedCityCache,
        readCache,
        writeCache
    };
}
